import React, { useState } from 'react';
import * as styles from './fileUpload.styles';
import uploadIcon from '../../assets/uploadIcon.png';
import { Card } from 'flowbite-react';

type FileUploadCardProps = {
    label: string;
    subtitleText?: string;
    onChange?: (file: File | null) => void;
    current?:File | null
};

const FileUploadCard = ({ label, subtitleText, onChange,current }: FileUploadCardProps) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(current ?? null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files ? e.target.files[0] : null;
        setSelectedFile(file);
        if (onChange) {
            onChange(file);
        }
    };

    const handleRemoveFile = () => {
        setSelectedFile(null);
        if (onChange) {
            onChange(null);
        }
    };

    return (
        <div className={styles.container}>
            <label className={styles.labelStyle}>{label}</label>
            {subtitleText && (<p className="text-xs">{subtitleText}</p>)}
            
            <Card>
                <input
                    type="file"
                    id={`file-upload-${label.toLowerCase().replace(/\s/g, '-')}`}
                    className={styles.inputHidden}
                    onChange={handleFileChange}
                />
                <label htmlFor={`file-upload-${label.toLowerCase().replace(/\s/g, '-')}`} className={styles.labelContainer}>
                    <img src={uploadIcon} className={styles.iconStyle} alt="Upload Icon" />
                    <p className={styles.textStyle}>
                        <span className={styles.textBold}>Click to upload</span> or drag and drop
                    </p>
                    <p className={styles.subTextStyle}>SVG, PNG, JPG or GIF (max. 800x400px)</p>
                </label>
                {selectedFile && (
                    <div className={styles.fileInfo}>
                        <p className={styles.fileName}>{selectedFile.name}</p>
                        <img
                            src={URL.createObjectURL(selectedFile)}
                            className={styles.previewImage}
                            alt="Selected file preview"
                        />
                        <button
                            type="button"
                            className={styles.removeButton}
                            onClick={handleRemoveFile}
                        >
                            Remove
                        </button>
                    </div>
                )}
            </Card>
        </div>
    );
};

export default FileUploadCard;
